// Package Imports
import { SearchOutlined } from '@ant-design/icons';
import { Form, Input } from 'antd';

// Project Imports
import { SearchInputProps } from 'components/search/type';
import ConfigStyle from 'core/constants/ConfigStyle';

const SearchInput = ({
  name,
  style,
  onChange,
  placeholder,
}: SearchInputProps) => (
  <Form.Item name={name} noStyle style={style}>
    <div className="search-input-container">
      <Input
        className="w-full py-2"
        onChange={onChange}
        size="large"
        placeholder={placeholder}
        suffix={
          <SearchOutlined style={{ color: ConfigStyle.colors.searchIcon }} />
        }
      />
    </div>
  </Form.Item>
);

export default SearchInput;
